module.exports = __webpack_public_path__ + "static/media/CACAO_04.491d6569.png";